import { CostBudgetTable } from './cost-budget-table';
import type { CostBudget } from '@/types/budget.types';

interface CostBudgetViewProps {
  projectId: number;
  data?: CostBudget;
  resourceBudget?: any;
  onEdit?: () => void;
  onExport?: () => void;
  onHistory?: () => void;
}

export function CostBudgetView({ projectId, data, resourceBudget, onEdit, onExport, onHistory }: CostBudgetViewProps) {
  return (
    <div className="space-y-6">
      <CostBudgetTable 
        projectId={projectId?.toString() || '0'}
        categories={data?.categories || []}
        totals={data?.totals}
        resourceBudget={resourceBudget}
        onEdit={onEdit}
        onExport={onExport}
        onHistory={onHistory}
      />
    </div>
  );
}
